<h1 mat-dialog-title>
  {{ (isEdit ? 'PROJECT.FINANCIAL_OPEX.EDIT_ITEM' : 'PROJECT.FINANCIAL_OPEX.ADD_ITEM') | anessaTranslation: trigger }}
</h1>
<mat-dialog-content>
  <form #opexForm="ngForm"
        (ngSubmit)="onSaveClick()">
    <div class="flex-container">
      <div class="flex-box border-shadow">
        <h3 class="compact-header-margin" anessaTranslation="PROJECT.FINANCIAL_OPEX.NAME"></h3>
        <mat-form-field>
          <input
            matInput
            type="text"
            id="name"
            name="name"
            required
            disabled
            [(ngModel)]="opex.name">
        </mat-form-field>
      </div>
    </div>
    <div class="flex-container">
      <div class="flex-box border-shadow">
        <h3 class="compact-header-margin" anessaTranslation="PROJECT.FINANCIAL_OPEX.COST"></h3>
        <div class="flex-container"
             [ngClass]="{'separator-wrapper': opex.type !== FinancialOpexType.MAJOR_MAINT}"
        >
          <div class="flex-box"
               style="padding-left: 0; padding-top: 0; padding-bottom: 0;"
          >
            <app-unit-value [units]="'Currency'"
                            [editable]="opex.type !== null"
                            name="cost"
                            [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
                            [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
                            [(ngModel)]="opex.cost">
            </app-unit-value>
          </div>
          <ng-container *ngIf="opex.type !== FinancialOpexType.MAJOR_MAINT">
            <div class="separator-text">
              <div anessaTranslation="PROJECT.COMMON.PER"></div>
            </div>
            <div class="flex-box"
                 style="padding-right: 0;"
            >
              <app-unit-value [units]="'Period'"
                              [editable]="opex.type !== null"
                              [disableUnit]="true"
                              [setGreaterThanValue]="0"
                              name="period"
                              [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
                              [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
                              [(ngModel)]="opex.period">
              </app-unit-value>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="fatbuttongroup">
  <button
    mat-button
    class="btn-fat btn-green"
    type="button"
    (click)="onSaveClick()"
    anessaTranslation="PROJECT.COMMON.SAVE">
  </button>
  <button
    mat-button
    class="btn-fat btn-red"
    type="button"
    (click)="onCancelClick()"
    anessaTranslation="PROJECT.COMMON.CANCEL">
  </button>
</mat-dialog-actions>
